export { Registry as default } from './Registry'
